// extracted by mini-css-extract-plugin
export default {"mediaMediumUp":"(min-width: 48em)","logoWide":"_4B9bnx4Cf0BM09TXMGEEEQ==","logo":"W+ytfdlxZFkGchZv3MWE7g==","img":"_8SiPXj+TysNYjCsQaiyQUQ=="};